module.exports = __webpack_public_path__ + "img/station-icon.39575487.png";